<template>
  <div class="flex flex-col w-96">
    <div class="bg-neutral-secondary rounded-md px-4 py-3 mb-2">
      <div class="grid grid-flow-row grid-cols-3">
        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press pb-3 self-center col-span-1"
        >
          {{ t('common.amount') }}
        </NText>

        <div class="flex justify-end items-center pb-3 col-span-2">
          <NumberFormatter
            #="{ number }"
            :value="withdrawal.requestWithdrawalValue"
          >
            <NText variant="caption1" weight="medium">
              {{ number }}
              <NText
                variant="caption1"
                class="text-neutral-secondary text-left align-middle"
              >
                {{ t('misc.rial') }}
              </NText>
            </NText>
          </NumberFormatter>
        </div>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press pb-3 self-center col-span-1"
        >
          {{ t('common.date') }} {{ t('common.submit_request') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-neutral-secondary-press pb-3 col-span-2"
        >
          {{ d(withdrawal.requestEntryDate, 'shortTime', 'en') }} ,
          {{ withdrawal.requestStringDate }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press border-b border-neutral-secondary self-center pb-3 col-span-1"
        >
          {{ t('common.requestStatus') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          :class="{
            'text-brand-primary': REQUEST_STATUS_ID.done.includes(
              withdrawal.requestStateId
            ),
            'text-critical-primary': REQUEST_STATUS_ID.failed.includes(
              withdrawal.requestStateId
            ),
            'text-neutral-secondary-press': REQUEST_STATUS_ID.canceled.includes(
              withdrawal.requestStateId
            ),
          }"
          class="flex justify-end items-center text-neutral-secondary-press border-b border-neutral-secondary pb-3 col-span-2"
        >
          {{
            withdrawal.requestState !== t('withdrawal.accountingDocument')
              ? withdrawal.requestState
              : t('withdrawal.requested')
          }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press py-3 self-center col-span-1"
        >
          {{ t('withdrawal.withdrawalDate') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-neutral-secondary-press py-3 col-span-2"
        >
          {{ withdrawal.requestDepositStringDate }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press border-b border-neutral-secondary self-center pb-3 col-span-1"
        >
          {{ t('withdrawal.accountNumber') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-neutral-secondary-press border-b border-neutral-secondary pb-3 col-span-2"
        >
          {{ withdrawal.destinationAccount }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press self-center pt-3 col-span-1"
        >
          {{ t('deposit.requestCode') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-neutral-secondary-press pt-3 col-span-2"
        >
          {{ withdrawal.requestSerialNumber }}
        </NText>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { WithdrawalItem } from '@libs/api-reference';
import { REQUEST_STATUS_ID } from '@core/cash';

import NumberFormatter from '@/components/Number.vue';

type WithdrawalProps = {
  withdrawal: WithdrawalItem;
};

defineProps<WithdrawalProps>();

const { t, d } = useI18n();
</script>
